import { render, staticRenderFns } from "./UnusualActivityComponent.vue?vue&type=template&id=4618d1b6"
import script from "./UnusualActivityComponent.vue?vue&type=script&lang=js"
export * from "./UnusualActivityComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports